module.exports = __webpack_public_path__ + "img/repair.1063c2d9.png";